document.addEventListener('DOMContentLoaded', function () {
	const targets = document.querySelectorAll('.animated-paragraph');

	if (!targets.length || !window.IntersectionObserver) {
		targets.forEach((target) => target.classList.add('is-visible'));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			});
		},
		{ threshold: 0.15 }
	);

	targets.forEach((target) => observer.observe(target));
});
